import * as constants from "../../../constants"

export default function useConstants() {
	return {
		...constants
	}
}
